import FavoriteButton from "./favorite-button";

export default FavoriteButton;